<app-manglish-suggestion *ngIf="isManglish" [manglishPattern]="manglishPattern"></app-manglish-suggestion>

<div class="mb-3">
  <!-- <div class="textarea-container" *ngIf="inputOptions.inputarea==='textarea'&&isMalayalam">
    <textarea autosize class="autogrow form-control form-control-sm transition-height" manglishText (minput)="handleMlInput($event)"
      (ngModelChange)="keyPress($event)" (keydown)="onkeyDown($event)" (keyup)="onkeyup($event)" #input="manglishConverter" type="other"
      [keyboard]="inputType" placeholder="{{placeholder}}" [readonly]="isDisable"></textarea>
    <span class="input-group-text" (click)="openKeyBoard($event)">
      <i class="material-icons keyboard"></i>
    </span>
  </div>
  <div class="textarea-container" *ngIf="inputOptions.inputarea==='textarea'&&!isMalayalam">
    <textarea autosize class="autogrow form-control form-control-sm transition-height" manglishText (minput)="handleMlInput($event)"
      (keydown)="onkeyDown($event)" (keyup)="onkeyup($event)" #input="manglishConverter" type="other" [keyboard]="inputType" placeholder="{{placeholder}}"
      [readonly]="isDisable"></textarea>
  </div> -->
  <div class="textarea-container" *ngIf="inputOptions.inputarea==='textarea'" >
    <textarea autosize [attr.rows]="rowSize" class="autogrow form-control form-control-sm transition-height" manglishText
      (patternOutput)=" manglishPattern=$event" (minput)="handleMlInput($event)" (ngModelChange)="keyPress($event)"
      (keydown)="onkeyDown($event)" #input="manglishConverter" type="other" [keyboard]="inputType"
      placeholder="{{placeholder}}" [readonly]="isDisable"></textarea>
    <div class="input-group-append" *ngIf="inputOptions.keyboardEnable&&isMalayalam">
      <span class="input-group-text" (click)="openKeyBoard($event)">
        <i class="material-icons keyboard"></i>
      </span>
    </div>
  </div>
  <ng-container *ngIf="inputOptions.inputarea==='input'">
    <div class="input-group">
      <input class="form-control form-control-sm" (minput)="handleMlInput($event)" (ngModelChange)="keyPress($event)"
        (keydown)="onkeyDown($event)" (patternOutput)=" manglishPattern=$event" #input="manglishConverter" type="other"
        [keyboard]="inputType" placeholder="{{placeholder}}" [readonly]="isDisable">
      <div class="input-group-append" *ngIf="inputOptions.keyboardEnable&&isMalayalam">
        <span class="input-group-text" (click)="openKeyBoard($event)">
          <i class="material-icons keyboard"></i>
        </span>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="mb-3" style="margin-top: 0!important; margin-bottom: 0!important;">
        <input class="form-control form-control-sm" (keydown)="onkeyDown($event)" #input="manglishConverter"
          type="other" placeholder="{{placeholder}}" (minput)="handleMlInput($event)" [keyboard]="inputType"
          (patternOutput)=" manglishPattern=$event" [readonly]="isDisable">
      </div>
    </ng-template>
  </ng-container>

  <ng-content></ng-content>
</div>
<ng-container *ngIf="!isDisable&&isMalayalam">
  <div 
     #keyBoardDiv cdkDragHandle cdkDrag
    style="position: absolute;opacity: 1;z-index: 1000;" (click)="onDrag($event)" >

    <app-overlay-panel #overlay [showCloseIcon]="true" [dismissable]="false" *ngIf="!isDisable" >
      <div style="cursor: all-scroll;">&nbsp; </div>
      <section>
        <table>
          <tbody class="ui-keyboard-keyset ui-keyboard-keyset-normal">
            <tr *ngFor="let num of numbers,let k = index">
              <td *ngFor="let letter of layout.slice(num, numbers[k+1]),let i = index">
                <button (click)="clickButton(letter,$event)" (mouseenter)="preventEvent($event)"
                  (mousedown)="preventEvent($event)" (mouseup)="preventEvent($event)" type="keyboard"
                  aria-disable="false" tabindex="-1"
                  class="ui-keyboard-button ui-keyboard-3346 ui-state-default ui-corner-all">
                  <span class="ui-keyboard-text">{{letter}}</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </app-overlay-panel>
  </div>
</ng-container>